class SingleWorks {
  constructor(el, opt) {
    this.rootSelectors = (Array.isArray(el) ? el : [el]).map((name) => `.${name}`);
    const hasTargetPage = this.rootSelectors.some((selector) => document.querySelector(selector));

    if (hasTargetPage) {
      this.initFloatCta();
      this.event();
    }
  }

  initFloatCta() {
    const floatCta = document.querySelector('.js-works-float-cta');
    const footer = document.querySelector('.js-footer');
    if (!floatCta) return;

    let ticking = false;

    const update = () => {
      const footerReached = footer
        ? footer.getBoundingClientRect().top <= window.innerHeight
        : false;
      floatCta.classList.toggle('is-hidden', footerReached);
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  event() {
    const findWithinRoots = (selector) => (
      this.rootSelectors.flatMap((rootSelector) => (
        Array.from(document.querySelectorAll(`${rootSelector} ${selector}`))
      ))
    );

    const createSlider = ({
      wrapper,
      swiper,
      name,
      spaceBetween = 0,
      slidesPerView = 'auto',
      breakpoints = null,
      withControls = true,
      loop = null,
    }) => {
      const wrapperEls = findWithinRoots(wrapper);
      if (wrapperEls.length < 1) return [];

      return Array.from(wrapperEls).map((wrapperEl) => {
        const swiperEl = wrapperEl.querySelector(swiper);
        if (!swiperEl) return null;

        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        const swiperOptions = {
          loop: loop !== null ? loop : slideCount > 2,
          slidesPerView,
          spaceBetween,
          speed: 500,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
        };

        if (breakpoints) {
          swiperOptions.breakpoints = breakpoints;
        }

        if (withControls) {
          swiperOptions.pagination = {
            el: wrapperEl.querySelector(`.${name}-swiper-pagination`),
            type: 'fraction',
            formatFractionCurrent: (number) => String(number).padStart(2, '0'),
            formatFractionTotal: (number) => String(number).padStart(2, '0'),
          };
          swiperOptions.navigation = {
            nextEl: wrapperEl.querySelector(`.${name}-swiper-button-next`),
            prevEl: wrapperEl.querySelector(`.${name}-swiper-button-prev`),
          };
        }

        const instance = new Swiper(swiperEl, swiperOptions);

        instance.autoplay.stop();
        return { wrapperEl, instance };
      }).filter(Boolean);
    };

    const sliders = [
      ...createSlider({
        wrapper: '.js-works-career-swiper-wrapper',
        swiper: '.js-works-career-swiper',
        name: 'works-career',
        spaceBetween: 8,
      }),
      ...createSlider({
        wrapper: '.js-works-interview-swiper-wrapper',
        swiper: '.js-works-interview-swiper',
        name: 'works-interview',
        spaceBetween: 0,
      }),
      ...createSlider({
        wrapper: '.js-recruit-gallery-swiper-wrapper',
        swiper: '.js-recruit-gallery-swiper',
        name: 'recruit-gallery',
        spaceBetween: 8,
        withControls: false,
        loop: false,
        breakpoints: {
          768: {
            spaceBetween: 33,
          },
        },
      }),
    ];

    if (sliders.length < 1) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const target = sliders.find((item) => entry.target === item.wrapperEl);
        if (!target) return;
        if (entry.isIntersecting) {
          target.instance.autoplay.start();
        } else {
          target.instance.autoplay.stop();
        }
      });
    }, { threshold: 0.1 });

    sliders.forEach((item) => observer.observe(item.wrapperEl));
  }
}
